<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.tachometer-alt-regular"></svg-vue>
          <h1 class="content-title">
            {{ $t('Dashboard') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <button @click="reload" class="btn btn-app" type="button">
            <svg-vue class="w-4 h-4" icon="font-awesome.sync-regular"></svg-vue>
          </button>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="mb-2">
        <div class="grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6">
          <div class="bg-white overflow-hidden rounded-md shadow border-t-2 border-green-600">
            <loading :status="loading.states"></loading>
            <div class="px-2 py-1 sm:p-2">
              <div class="text-sm font-medium truncate">
                {{ $t('Sales') }}
              </div>
              <div class="mt-1 text-3xl font-semibold text-gray-900">
                {{ states.sales }}
              </div>
            </div>
          </div>
          <div class="bg-white overflow-hidden rounded-md shadow border-t-2 border-green-600">
            <loading :status="loading.states"></loading>
            <div class="px-2 py-1 sm:p-2">
              <div class="text-sm font-medium truncate">{{ $t('Repairs') }}</div>
              <div class="mt-1 text-3xl font-semibold text-gray-900">
                {{ states.repairs }}
              </div>
            </div>
          </div>
          <div class="bg-white overflow-hidden rounded-md shadow border-t-2 border-green-600">
            <loading :status="loading.states"></loading>
            <div class="px-2 py-1 sm:p-2">
              <div class="text-sm font-medium truncate">{{ $t('Products') }}</div>
              <div class="mt-1 text-3xl font-semibold text-gray-900">
                {{ states.products }}
              </div>
            </div>
          </div>
          <div class="bg-white overflow-hidden rounded-md shadow border-t-2 border-green-600">
            <loading :status="loading.states"></loading>
            <div class="px-2 py-1 sm:p-2">
              <div class="text-sm font-medium truncate">
                {{ $t('Categories') }}
              </div>
              <div class="mt-1 text-3xl font-semibold text-gray-900">
                {{ states.categories }}
              </div>
            </div>
          </div>
             <div class="bg-white overflow-hidden rounded-md shadow border-t-2 border-green-600">
            <loading :status="loading.states"></loading>
            <div class="px-2 py-1 sm:p-2">
              <div class="text-sm font-medium truncate">
                {{ $t('Custom bills') }}
              </div>
              <div class="mt-1 text-3xl font-semibold text-gray-900">
                {{ states.custom_bills }}
              </div>
            </div>
          </div>
             <div class="bg-white overflow-hidden rounded-md shadow border-t-2 border-green-600">
            <loading :status="loading.states"></loading>
            <div class="px-2 py-1 sm:p-2">
              <div class="text-sm font-medium truncate">
                {{ $t('Custom products') }}
              </div>
              <div class="mt-1 text-3xl font-semibold text-gray-900">
                {{ states.custom_products }}
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2 grid grid-cols-1 gap-2 sm:grid-cols-2">
          <div class="bg-white overflow-hidden rounded-md shadow border-t-2 border-green-600">
            <loading :status="loading.states"></loading>
            <div class="px-2 py-1 sm:p-2">
              <div class="text-sm font-medium truncate">
                {{ $t('Total sale amount') }}
              </div>
              <div class="mt-1 font-semibold text-gray-900">
                {{ states.total_sale_amount | currency }}
              </div>
            </div>
          </div>
          <div class="bg-white overflow-hidden rounded-md shadow border-t-2 border-green-600">
            <loading :status="loading.states"></loading>
            <div class="px-2 py-1 sm:p-2">
              <div class="text-sm font-medium truncate">
                {{ $t('Sole item cost Amount') }}
              </div>
              <div class="mt-1 font-semibold text-gray-900">
                {{ states.total_sale_cost | currency }}
              </div>
            </div>
          </div>
          <div class="bg-white overflow-hidden rounded-md shadow border-t-2 border-green-600">
            <loading :status="loading.states"></loading>
            <div class="px-2 py-1 sm:p-2">
              <div class="text-sm font-medium truncate">
                {{ $t('Sales Profit Amount') }}
              </div>
              <div class="mt-1 font-semibold text-gray-900">
                {{ states.total_sale_profit | currency }}
              </div>
            </div>
          </div>
           <div class="bg-white overflow-hidden rounded-md shadow border-t-2 border-green-600">
            <loading :status="loading.states"></loading>
            <div class="px-2 py-1 sm:p-2">
              <div class="text-sm font-medium truncate">
                {{ $t('Total sale tax') }}
              </div>
              <div class="mt-1 font-semibold text-gray-900">
                {{ states.total_sale_tax| currency }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="py-4">
        <div class="flex flex-col bg-white rounded-md shadow border-t-2 border-green-600">
          <div class="flex justify-between p-4">
            <div class="content-title">
              {{ $t('Annual sales') }}
            </div>
          </div>
          <div class="p-4 pt-0">
            <loading :status="loading.chart"></loading>
            <line-chart :chart-data="chartData" :height="350" ref="chart"></line-chart>
          </div>
        </div>
      </div>
      <div class="md:flex">
        <div class="py-2 md:w-3/12">
          <div class="p-4 mr-2 flex flex-col bg-white rounded-md shadow border-t-2 border-green-600">
            <pie-chart :data="pieChartData" :options="pieChartOptions" ref="pieChart"></pie-chart>
          </div>
        </div>
        <div class="py-2 md:w-3/4">
          <div class="overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
            <div class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-purple-200">
              <loading :status="loading.sales"></loading>
              <table class="min-w-full">
                <thead>
                  <tr>
                    <th
                      class="px-6 py-3 border-b border-green-700 bg-green-600 bg-opacity-75 text-left text-xs font-semibold text-white uppercase tracking-wider"
                    >
                      {{ $t('Image') }}
                    </th>
                    <th
                      class="px-6 py-3 border-b border-green-700 bg-green-600 bg-opacity-75 text-left text-xs font-semibold text-white uppercase tracking-wider"
                    >
                      {{ $t('Product name') }}
                    </th>
                    <th
                      class="px-6 py-3 border-b border-green-700 bg-green-600 bg-opacity-75 text-left text-xs font-semibold text-white uppercase tracking-wider"
                    >
                      {{ $t('price') }}
                    </th>
                    <th
                      class="px-6 py-3 border-b border-green-700 bg-green-600 bg-opacity-75 text-left text-xs font-semibold text-white uppercase tracking-wider"
                    >
                      {{ $t('Quantity') }}
                    </th>
                    <th
                      class="px-6 py-3 border-b border-green-700 bg-green-600 bg-opacity-75 text-left text-xs font-semibold text-white uppercase tracking-wider"
                    >
                      {{ $t('Total') }}
                    </th>
                    <th class="px-6 py-3 border-b border-green-700 bg-green-600 bg-opacity-75"></th>
                  </tr>
                </thead>

                <tbody class="bg-white">
                  <template v-if="sales.length > 0">
                    <tr v-for="(product, index) in sales" :key="index">
                      <td class="px-4 py-2 whitespace-no-wrap border-b border-gray-200">
                        <div class="flex items-center">
                          <img :alt="$t('image')" :src="product.image" class="h-12 w-12 rounded-md" />
                        </div>
                      </td>

                      <td class="px-3 py-4 border-b border-gray-200 max-w-0 w-full whitespace-no-wrap">
                        <div class="text-sm leading-5 text-gray-500 w-full truncate">
                          {{ product.name }}
                        </div>
                      </td>
                      <td class="px-3 py-4 border-b border-gray-200 whitespace-no-wrap text-gray-500 text-center">
                        {{ product.price | currency }}
                      </td>
                      <td class="px-3 py-4 border-b border-gray-200 whitespace-no-wrap text-gray-500 text-center">
                        {{ product.qty }}
                      </td>
                      <td class="px-3 py-4 border-b border-gray-200 whitespace-no-wrap text-gray-500 text-center">
                        {{ product.sub_total | currency }}
                      </td>

                      <td class="px-4 py-2 whitespace-no-wrap text-right border-b border-gray-200 text-sm leading-5 font-medium">
                        <router-link class="text-indigo-600 hover:text-indigo-900" :to="'/admin/sale-orders/' + product.uuid">
                          {{ $t('more') }}
                        </router-link>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="5" class="px-6 py-3 leading-4 font-medium text-gray-500 text-center">
                        {{ $t('No sales') }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import LineChart from '@/components/line-chart';
import PieChart from '@/components/pie-chart';

import { pickBy, identity } from 'lodash';
export default {
  name: 'dashboard',
  metaInfo() {
    return {
      title: this.$i18n.t('Admin dashboard'),
    };
  },
  components: { LineChart, PieChart },
  data() {
    return {
      pieChartOptions: {
        hoverBorderWidth: 20,
      },
      pieChartData: {
        hoverBackgroundColor: 'red',
        hoverBorderWidth: 10,
        labels: [this.$t('Total profit'), this.$t('Total cost')],
        datasets: [
          {
            label: this.$t('Payments'),
            backgroundColor: ['#7cc884', '#4c997b'],
            data: [0, 0],
          },
        ],
      },
      loading: {
        states: false,
        chart: false,
        sales: false,
      },

      sales: [],
      states: {
        categories: 0,
        total_sale_tax: 0,
        total_sale_amount: 0,
        products: 0,
        repairs: 0,
        sales: 0,
        custom_bills:0,
        custom_products:0,
        total_sale_cost: 0,
        total_sale_profit: 0,
      },
      chartData: {
        labels: [
          this.$t('Jan'),
          this.$t('Feb'),
          this.$t('Mar'),
          this.$t('Apr'),
          this.$t('May'),
          this.$t('Jun'),
          this.$t('Jul'),
          this.$t('Aug'),
          this.$t('Sept'),
          this.$t('Oct'),
          this.$t('Nov'),
          this.$t('Dec'),
        ],
        datasets: [
          {
            label: this.$i18n.t('Sales'),
            backgroundColor: '#7cc884',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
      },
    };
  },
  mounted() {
    this.reload();
  },

  computed: {
    lineChartDatasets() {
      return this.chartData.datasets[0].data;
    },
    pieChartDatasets() {
      return this.pieChartData.datasets[0].data;
    },
  },
  watch: {
    pieChartDatasets() {
      this.$refs.pieChart.update();
    },
    lineChartDatasets() {
      this.$refs.chart.update();
    },
  },
  methods: {
    reload() {
      this.getStates();
      this.getData();
      this.getLastSales();
    },

    getStates() {
      this.loading.states = true;
      axios
        .get(route('dashboard.statuses'))
        .then((response) => {
          this.loading.states = false;
          this.states = response.data;
          this.pieChartData.datasets[0].data = [this.states.total_sale_cost, this.states.total_sale_profit];
        })
        .catch(() => {
          this.loading.states = false;
        });
    },
    getLastSales() {
      this.loading.sales = true;
      axios
        .get(route('dashboard.last-sales'))
        .then((response) => {
          this.loading.sales = false;
          this.sales = response.data;
        })
        .catch(() => {
          this.loading.sales = false;
        });
    },
    getData() {
      this.loading.chart = true;
      axios
        .get(route('dashboard.annual'), {
          params: {
            ...this.filters,
          },
        })
        .then((response) => {
          this.chartData.datasets[0].data = response.data;
          this.loading.chart = false;
        })
        .catch(() => {
          this.loading.chart = false;
        });
    },
  },
};
</script>
